<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :show-date="showDate"
        :show-dates="showDates"
        :form-component="formComponent"
        tourists-label="guest"
        show-tourists
        show-duration
    >
        <template v-slot:title>
            {{ locationLabel }}
        </template>
        <template v-if="info.duration" v-slot:content>
            <div>{{ `${touristsTotal} ${$t('guest', touristsTotal)}` }}</div>
            <div v-if="info.duration">
                {{
                    `${info.duration} ${$t('day', info.duration)} / ${info.duration - 1} ${$t(
                        'night',
                        info.duration - 1
                    )}`
                }}
            </div>
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import TourSearchForm from '~src/components/tours/search/forms/tourSearchForm.src'

    @Component({
        components: {
            SearchSummaryLayout,
            TourSearchForm,
        },
    })
    export class TourSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest
        @Prop({default: false, type: Boolean}) showDate
        @Prop({default: false, type: Boolean}) showDates
        @Prop({default: () => ({}), type: Object}) info

        get locationLabel() {
            return `${toursRuntimeStore.arrivalCity.name}, ${toursRuntimeStore.arrivalCity.countryName}`
        }

        get startDateFrom() {
            return this.searchRequest.startDateFrom
        }

        get startDateTo() {
            return this.searchRequest.startDateTo
        }

        get touristsTotal() {
            return toursRuntimeStore.touristsTotal(this.searchRequest)
        }

        get nightsFrom() {
            return this.searchRequest.durationFrom - 1
        }

        get nightsTo() {
            return this.searchRequest.durationTo - 1
        }

        get duration() {
            return `${this.$t('tours.from')} ${this.nightsFrom} ${this.$t('night', this.nightsFrom)} -
                ${this.$t('tours.to')} ${this.nightsTo} ${this.$t('night', this.nightsTo)}`
        }

        get formComponent() {
            return resolveComponent('TourSearchForm')
        }
    }

    export default TourSearchSummary
</script>
